import React from "react";
import MapLeaflet from "../../../../components/Map";
import localeText from "../../../../locale";

const StoresMap = ({ plan, userTypeInfo }) => {
  return (
    <div id="StoresMap">
      <MapLeaflet isUserDashboard={true} style={{ height: "79dvh" }} userTypeInfo={userTypeInfo} />
    </div>
  );
};

export default StoresMap;

